require('./multiMap.js');



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/multiMap/index.js
// module id = 426
// module chunks = 0